import { render, staticRenderFns } from "./layout-pay.vue?vue&type=template&id=615e5b18&scoped=true&"
import script from "./layout-pay.vue?vue&type=script&lang=js&"
export * from "./layout-pay.vue?vue&type=script&lang=js&"
import style0 from "./layout-pay.vue?vue&type=style&index=0&lang=less&"
import style1 from "./layout-pay.vue?vue&type=style&index=1&id=615e5b18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615e5b18",
  null
  
)

export default component.exports